<template>
    <div class="connector-card" :style="{ position: 'relative' }">
        <v-btn
            class="connect-btn"
            @click="connectSource"
            v-if="checkRole(projectId, 'project:connector:edit') && !isDisabled"
            :disabled="!checkRole(projectId, 'project:connector:edit') || isDisabled"
            x-small
            outlined
        >
            Добавить
        </v-btn>
        <div class="connector-card-content">
            <v-avatar :color="sourceAvatar.color" size="42" class="mx-2 my-2 inactive-avatar">
                <v-img 
                    v-if="sourceAvatar.image" 
                    style="position: absolute;"
                    transition="slide-x-transition" 
                    :src="sourceAvatar.image"
                    class="inactive-image"
                />
                <span v-else>{{ sourceAvatar.symbol }}</span>
            </v-avatar>
            <div class="connector-card-name-wrapper">
                <h3 :title="sourceAvatar.name">{{ sourceAvatar.name }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkRole } from '@root/src/helpers/roles'
import { CONNECTOR_TYPES } from '@/vars/general'

export default {
    name: 'InactiveSourceCard',
    props: {
        connectorType: {
            type: String,
            required: true,
        },
        projectId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['connectorAvatarByType']),
        sourceAvatar() {
            return this.connectorAvatarByType(this.connectorType) || {
                color: 'white',
                symbol: '?',
                name: 'Неизвестно',
            }
        },
        isDisabled() {
            // lenaLenina не должна быть доступна для подключения
            return this.connectorType === CONNECTOR_TYPES.lenaLenina
        },
    },
    methods: {
        checkRole,
        connectSource() {
            if (this.isDisabled) return
            const path = this.$router.currentRoute.path.split('/').slice(0, 3).join('/')
            // Переходим на страницу добавления коннектора с предвыбранным типом источника
            this.$router.push(`${path}/addConnectorStage1?type=${this.connectorType}`)
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'
.connector-card
    width: 328px
    border: 1px solid #0000001F
    border-radius: 4px
    background-color: #F5F5F5
.connector-card-name-wrapper
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden
    flex: 1
    min-width: 0
    h3
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
        margin: 0
::v-deep .connect-btn
    position: absolute
    top: 8px
    right: 8px
    z-index: 1
    min-width: auto !important
    padding: 0px 4px !important
    height: 16px !important
    white-space: nowrap !important
    font-size: 8px !important
    background: transparent !important
    border: 1px solid #4CAF50 !important
    color: #4CAF50 !important
    &.v-size--x-small
        min-width: auto !important
        padding: 0px 4px !important
        height: 16px !important
    .v-btn__content
        font-size: 8px !important
        padding: 0 !important
        height: auto !important
        min-width: auto !important
        color: #4CAF50 !important
    .v-icon
        font-size: 10px !important
        width: 10px !important
        height: 10px !important
        margin-left: 2px !important
        color: #4CAF50 !important
.connector-card-content
    padding-left: 16px
    padding-right: 16px
    padding-top: 7px
    padding-bottom: 7px
    display: flex
    flex-direction: row
    align-items: center
button:focus
    outline: 0
.inactive-image
    filter: grayscale(100%) brightness(0.85)
    opacity: 0.6
::v-deep .inactive-avatar
    background-color: #9E9E9E !important
</style>

